import _ from 'lodash'
import { Marker, Grid, Input } from '@design-systems/canvas-ui'
import RFI3QuestionWindow from '../globalComponents/RfiCommons/RFI3QuestionWindow'
import {
  RFI_TYPE_SUPPLIER,
  MESSAGE_VALIDATION_FAILED,
  RFI_TYPE_LOCATION,
  PARAM_MANUFACTURING_TYPE_ID,
  RFI_LAST_MODIFIED_DATE,
} from './commonConstants'
import VettingTimelineView from '../globalComponents/Vetting/VettingTimelineView'
import { Link } from 'react-router-dom'

const getAuditStatusLabel = (audit) => {
  if (audit?.vetting_status) return audit.vetting_status

  switch (audit?.vetting_status_code) {
    case 0:
      return 'Started'
    case 1:
      return 'Initiated'
    case 2:
      return 'Submitted'
    case 3:
      return 'Approved'
    case 4:
      return 'Rejected'
    case 5:
      return 'Sent Back'
    case 6:
      return 'Approved But Hold'
    case 7:
      return 'Approved Start Vfa'
    case 8:
      return 'Approved Bypass Vfa'
    case 9:
      return 'Review Complete'
    case 20:
      return 'System Approved'
    default:
      return '-'
  }
}

const normalizeAuditTrail = (auditTrials = []) => {
  if (!Array.isArray(auditTrials)) return []

  return auditTrials.map((audit) => ({
    ...audit,
    vetting_status: getAuditStatusLabel(audit || {}),
  }))
}

/**
 * Transform RFI Approval list data for MUI Grid
 * @param {*} vettingListData
 * @param {*} vettingType
 * @returns
 */
export const transformRfiApprovalData = (vettingListData, vettingType) => {
  if (vettingType === RFI_TYPE_SUPPLIER) {
    return vettingListData
      .filter((val) => val.vetting_type?.toLowerCase() === RFI_TYPE_SUPPLIER)
      .map((value, index) => {
        let timelineData = {
          auditTrail: normalizeAuditTrail(value.audit_trials),
          whatNext: value.what_todo_next,
          index: index,
          lastUpdateTimestamp: value.latest_status?.vetting_status_updated_date
            ? value.latest_status?.vetting_status_updated_date
            : null,
          vettingType: vettingType,
          supplierId: value.supplier_id,
          manufacturingType: value.manufacturing_type,
          manufacturingTypeId: value.manufacturing_type_id,
        }

        return {
          supplierId: {
            cellDisplay: (
              <p className="hc8-fs-050 hc8-txt-capitalize  hc8-pv-2x">
                <Link
                  to={`/internal/rfi1?supplierId=${value.supplier_id}&${PARAM_MANUFACTURING_TYPE_ID}=${value.manufacturing_type_id}`}
                >
                  <Input.Label className="hc8-fs-050 hc8-ma-none cursor-pointer hc8-clr-brand">
                    {value.supplier_id}
                  </Input.Label>
                </Link>
              </p>
            ),
          },
          supplierName: {
            cellDisplay: (
              <p
                className={'hc8-fs-050 hc8-pv-2x '}
                style={{
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word',
                  wordBreak: 'keep-all',
                }}
              >
                {value.supplier_name}
              </p>
            ),
          },
          manufacturingType: {
            cellDisplay: (
              <p className={'hc8-fs-050 hc8-mb-3x  hc8-pv-2x align-top-centre'}>
                {value.manufacturing_type}
              </p>
            ),
          },
          departments: {
            cellDisplay: (
              <div className="hc8-fs-050  hc8-pv-2x">
                {buildDepartmentChips(value.departments)}
              </div>
            ),
          },
          rfiTimeline: {
            cellDisplay: (
              <div className="hc8-fs-050  height-100pc align-centre-left">
                <VettingTimelineView timeline={timelineData} nodeCount={4} />
              </div>
            ),
          },
        }
      })
  } else {
    let filteredVettingList = []
    vettingListData
      .filter((val) => val.vetting_type.toLowerCase() === RFI_TYPE_LOCATION)
      .forEach((value, index) => {
        let timelineData = {
          auditTrail: normalizeAuditTrail(value.audit_trials),
          whatNext: value.what_todo_next,
          index: index,
          lastUpdateTimestamp: value.latest_status?.vetting_status_updated_date
            ? value.latest_status?.vetting_status_updated_date
            : null,
          vettingType: vettingType,
          locationId: value.location_id,
          supplierId: value.supplier_id,
          manufacturingType: value.manufacturing_type,
          manufacturingTypeId: value.manufacturing_type_id,
        }
        filteredVettingList.push({
          locationId: {
            cellDisplay: (
              <p className="hc8-fs-050 hc8-txt-capitalize  hc8-pv-2x">
                <Link
                  to={`/internal/rfi2?locationId=${value.location_id}&supplierId=${value.supplier_id}&${PARAM_MANUFACTURING_TYPE_ID}=${value.manufacturing_type_id}`}
                >
                  <Input.Label className="hc8-fs-050 hc8-ma-none cursor-pointer hc8-clr-brand">
                    {value.location_id}
                  </Input.Label>
                </Link>
              </p>
            ),
          },
          locationName: {
            cellDisplay: (
              <p
                style={{
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word',
                  wordBreak: 'keep-all',
                }}
                className={'hc8-fs-050 hc8-pv-2x'}
              >
                {value.location_name}
              </p>
            ),
          },
          manufacturingType: {
            cellDisplay: (
              <p className={'hc8-fs-050 hc8-mb-3x  hc8-pv-2x align-top-centre'}>
                {value.manufacturing_type}
              </p>
            ),
          },
          supplierId: {
            cellDisplay: (
              <p className="hc8-fs-050 hc8-txt-capitalize  hc8-pv-2x">
                {value.supplier_id}
              </p>
            ),
          },
          supplierType: {
            cellDisplay: (
              <div className="hc8-fs-050  hc8-pv-2x">{value.supplier_type}</div>
            ),
          },
          supplierNameLoc: {
            // TODO: This is a temporary fix to avoid sorting issue with canvas, rename the field to "supplierName" after enabling sorting for supplierName
            cellDisplay: (
              <p
                className={'hc8-fs-050 hc8-pv-2x'}
                style={{
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word',
                  wordBreak: 'keep-all',
                }}
              >
                {value.supplier_name}
              </p>
            ),
          },
          rfiTimeline: {
            cellDisplay: (
              <div className="hc8-fs-050  align-centre-left">
                <VettingTimelineView timeline={timelineData} nodeCount={4} />
              </div>
            ),
          },
        })
      })
    return filteredVettingList
  }
}

/**
 * Build department chips
 * @param {*} value
 * @returns
 */
export const buildDepartmentChips = (value) => {
  let departmentChips = []
  for (var key in value) {
    let deptText =
      value[key].department_id && value[key].department_name
        ? value[key].department_id + '-' + value[key].department_name
        : value[key].department_id
          ? value[key].department_id
          : value[key].department_name
    departmentChips.push(
      <Marker
        key={`chip-${key}-${value[key].department_id}`}
        size="sm"
        className="hc8-txt-uppercase hc8-clr-base hc8-fs-050 hc8-bg-base"
        style={{
          border: '1px solid var(--color-border-base-hover)',
          fontFamily: 'Helvetica For Target',
          height: '20px',
          margin: '1px',
          borderRadius: '20px',
        }}
      >
        {deptText}
      </Marker>,
    )
  }
  return departmentChips
}

/**
 * Render the RFI3 question section
 * Takes - 1. sectionContent  -> content to be shown on left (General section data)
 *         2. rfiAnswers      -> answers list
 *         3. sectionTemplate -> contains the template with the questions
 *         4. rfiMasterData   -> master data to show answer options in radiobutton etc
 *         5. handleAnswerUpdate -> callback to pass back updated answer/note etc
 * @param {*} isReadOnly
 * @param {*} sectionContent
 * @param {*} rfiAnswers
 * @param {*} sectionTemplate
 * @param {*} rfiMasterData
 * @param {*} handleAnswerUpdate
 * @param {*} supplierId
 * @param {*} locationId
 * @param {*} manufacturingTypeId
 * @param {*} rfi3Files
 * @param {*} handleFilesUpdate
 * @param {*} errorCache
 * @returns
 */
export const renderRFI3QuestionWindow = (
  isReadOnly,
  sectionContent,
  rfiAnswers,
  sectionTemplate,
  rfiMasterData,
  handleAnswerUpdate,
  supplierId,
  locationId,
  manufacturingTypeId,
  rfi3Files,
  handleFilesUpdate,
  errorCache = {},
) => {
  return (
    <Grid.Container className="hc8-pb-none">
      <Grid.Item
        size={{ xs: 6 }}
        className="hc8-pb-none border-top-grey-thin border-right-grey-thin"
      >
        {sectionContent}
      </Grid.Item>
      <Grid.Item size={{ xs: 6 }} className="hc8-pb-none border-top-grey-thin">
        <RFI3QuestionWindow
          isReadOnly={isReadOnly}
          rfiAnswers={rfiAnswers}
          sectionTemplate={sectionTemplate}
          rfiMasterData={rfiMasterData}
          errorCache={errorCache}
          updateAnswer={(newSectionAnswers) =>
            handleAnswerUpdate(newSectionAnswers)
          }
          supplierId={supplierId}
          locationId={locationId}
          manufacturingTypeId={manufacturingTypeId}
          rfi3Files={rfi3Files}
          updateRfiFiles={(newFilesList) => handleFilesUpdate(newFilesList)}
        />
      </Grid.Item>
    </Grid.Container>
  )
}

/**
 * Construct the error cache from error response payload
 * @param {*} errorPayload
 * @returns
 */
export const buildServiceErrorsCache = (errorPayload) => {
  if (
    errorPayload &&
    errorPayload.response?.status === 400 &&
    errorPayload.response?.data?.message?.toLowerCase() ===
      MESSAGE_VALIDATION_FAILED &&
    errorPayload.response.data.errors?.length
  ) {
    let errorTabs = []
    let errorSections = []
    let errorControls = {}

    errorPayload.response.data.errors.forEach((eachError) => {
      errorTabs.push(eachError?.tab)
      errorSections.push(eachError?.section)
      if (eachError.uid) {
        errorControls[eachError.uid] = eachError.error_message
      } else {
        errorControls[eachError.field_name] = eachError.error_message
      }
    })

    let finalCache = {
      tab: Array.from(new Set(errorTabs)),
      section: Array.from(new Set(errorSections)),
      controls: errorControls,
    }
    return finalCache
  }
}

/**
 * Consolidate error cache - Existing error cache + new error cache
 * @param {*} sectionId
 * @param {*} existingErrorCache
 * @param {*} sectionErrorCache
 * @returns
 */
export const consolidateErrorCache = (
  sectionId, //Current section id
  existingErrorCache,
  sectionErrorCache = null, //Current section errors
) => {
  //Case 1: Save successful - no error => remove all errors for sectionId
  //Case 2: Save failed (validation error) => remove all errors for sectionId + add new errors (newErrorCache)
  let updatedErrorCache = { controls: {} }

  //Existing error is present - filter out this section's errors
  if (!_.isEmpty(existingErrorCache)) {
    let newControls = {}
    let newTabs = []
    Object.keys(existingErrorCache.controls)
      .filter((eachKey) => eachKey.split('.')[1] !== sectionId) //index 1 = section
      .forEach((eachKey) => {
        newTabs.push(eachKey.split('.')[0]) //index 0 = tab
        newControls[eachKey] = existingErrorCache.controls[eachKey]
      })
    updatedErrorCache.controls = newControls
    updatedErrorCache.tab = Array.from(new Set(newTabs))
    updatedErrorCache.section = existingErrorCache.section?.filter(
      (s) => s !== sectionId,
    )
  }

  //If passed (existing) section has any error(sectionErrorCache) merge existing + new cache
  if (sectionErrorCache) {
    Object.keys(sectionErrorCache.controls).forEach((eachKey) => {
      updatedErrorCache.controls[eachKey] = sectionErrorCache.controls[eachKey]
    })
    updatedErrorCache.tab = updatedErrorCache.tab
      ? [...updatedErrorCache.tab, ...sectionErrorCache.tab]
      : sectionErrorCache.tab
    updatedErrorCache.section = updatedErrorCache.section
      ? [...updatedErrorCache.section, sectionId]
      : [sectionId]
  }

  return updatedErrorCache
}

/**
 * @param {Object} input - The original data object
 */
export const transformFilterResponse = (input) => {
  const labelMap = {
    manufacturing_type: 'Manufacturing Type',
    rfi1_status: 'RFI 1 Status',
    rfi2_status: 'RFI 2 Status',
    rfi3_status: 'RFI 3 Status',
    supplier_types: 'Supplier Type',
    ctv_sourcing_office: 'CTV Sourcing Office',
    ctp_sourcing_office: 'CTP Sourcing Office',
    ctp_psqa_office: 'CTP PSQA Office',
    rfi_last_modified_date: 'RFI Last Modified Date',
  }

  const result = {}

  if (input != null) {
    Object.entries(input).forEach(([key, valuesArray]) => {
      if (key !== 'rfi_type' && Array.isArray(valuesArray)) {
        result[key] = {
          name: labelMap[key] || key,
          values: valuesArray.map((item) => ({
            id: item.identifier ?? item,
            value: item.name ?? item,
          })),
        }
      }
    })
  }
  result[RFI_LAST_MODIFIED_DATE] = {
    name: labelMap[RFI_LAST_MODIFIED_DATE],
    values: [],
  }

  return result
}
